export const HUMAN_TRANSCRIPTION_PRICE_PER_HOUR = 135
